export const GET_COHORT_CONFIG = "GET_COHORT_CONFIG";
export const UPDATE_COHORT_CONFIG = "UPDATE_COHORT_CONFIG";

export const OPEN_COHORT_CONFIG_DIALOG = "OPEN_COHORT_CONFIG_DIALOG";
export const CLOSE_DIALOG = "CLOSE_COHORT_CONFIG_DIALOG";

export const OPEN_COHORT_CONFIG_TOAST = "OPEN_COHORT_CONFIG_TOAST";
export const CLOSE_COHORT_CONFIG_TOAST = "CLOSE_COHORT_CONFIG_TOAST";
